

import React from "react";
import { connect } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { hideToaster } from "./toasterActions";


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Toaster(props) {

    const { open, heading, message, variant, hideToaster } = props;

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        hideToaster();
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
        >
            <Alert onClose={handleClose} severity={variant} variant="standard">
                {heading && <strong style={{ display: "block" }}>{heading}</strong>}
                {message}
            </Alert>
        </Snackbar>
    );
}

const mapActionCreators = {
    hideToaster
};

const mapStateToProps = (state) => ({
    open: state.toaster.open,
    message: state.toaster.message,
    variant: state.toaster.variant,
    heading: state.toaster.heading,
});

export default connect(mapStateToProps, mapActionCreators)(Toaster);



// WEBPACK FOOTER //
// ./src/components/Toaster/index.js